import * as Common from '@/tenant/common';

export class Task extends Common.StateObject {
  constructor(){
    super('Task');
    this.binders.parent = new Common.ModelBinder(Common.Matter);
    this.workflowCode="task";
    this.workflowStateId = 1;//フラグ値を変更;    
  }
  public id: number = 0;
  public matter: number = 0;
  //public matter2: Models.Matter; 
  public name: string = '';
  public note: string = '';
  public type: number = 1;
  public pid: string = '';
  public status: number = 1;
  public limitDate: Date = new Date();
  public scheduledTime: number = 0;
  public reviewer: string = '';
  public parent: Common.Matter = null;
  public copy():any {
    const temp = super.copy() as Task;
    temp.id = 0;
    return temp;
  }
}

export class TaskQuery extends Common.LoadQuery {
  constructor(){
    super('TaskQuery', Task);
    this.sort = 'id';
  }

  public project: string = '';
  public category: string = '';
  public type: number = 127;
  public pid: string = '';
  public status: number = 15;
  public today: Date = new Date();
  public limitDateFrom: Date = null;
  public limitDateTo: Date = null;
  public updateOnFrom: Date = null;
  public updateOnTo: Date = null;
  public holder: string = '';
  public matter:number = 0;
  public id: number = 0;  
}
